import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 考生记录 — 状态机驱动, 仅允许查看与少量字段编辑 (备注/作废).
 */
export const examParticipantsConfig: CrudConfig = {
  resource: 'exam-participants',
  title: '考生记录',
  rowKey: 'id',
  searchFields: ['status', 'session'],
  disableCreate: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, readonly: true, hideInForm: true },
    { name: 'user_email', label: '考生', type: 'readonly', width: 200, ellipsis: true, readonly: true },
    { name: 'session', label: '场次 ID', type: 'number', width: 100, readonly: true },
    { name: 'session_name', label: '场次名称', type: 'readonly', ellipsis: true, readonly: true, hideInForm: true },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 130,
      options: [
        { label: '已报名', value: 'REGISTERED', status: 'Default' },
        { label: '已付费', value: 'PAID', color: 'cyan' },
        { label: '就绪', value: 'READY', color: 'blue' },
        { label: '进行中', value: 'IN_PROGRESS', status: 'Processing', color: 'blue' },
        { label: '上传中', value: 'UPLOADING', color: 'gold' },
        { label: '已提交', value: 'SUBMITTED', color: 'cyan' },
        { label: '评分中', value: 'SCORING', status: 'Processing' },
        { label: '已评分', value: 'SCORED', status: 'Success', color: 'green' },
        { label: '通过', value: 'PASSED', status: 'Success', color: 'green' },
        { label: '未通过', value: 'FAILED', status: 'Error', color: 'red' },
        { label: '已作废', value: 'CANCELLED', status: 'Error', color: 'red' },
        { label: '已超时', value: 'TIMEOUT', status: 'Warning', color: 'orange' },
      ],
    },
    { name: 'final_score', label: '最终得分', type: 'number', width: 100, readonly: true },
    { name: 'violation_count', label: '违规次数', type: 'number', width: 100, readonly: true, hideInSearch: true },
    { name: 'attempt_count', label: '尝试次数', type: 'number', width: 100, readonly: true, hideInSearch: true, hideInTable: true },
    { name: 'remark', label: '备注', type: 'textarea', hideInTable: true },
    { name: 'created_at', label: '报名时间', type: 'datetime', width: 180, readonly: true, hideInForm: true },
  ],
};
